import Head from "next/head";
import NewsRow from "../components/Elements/NewsRow/NewsRow";
// import VideoRow from "../components/VideoRow";
// import MiddleMenuRow from "../components/MiddleMenuRow";
import ImageRow from "../components/HomeCompo/ImageRow/ImageRow";
// import NewVideosRow from "../components/NewVideosRow";
import DKStatistic from "../components/HomeCompo/DKStatistic/DKStatistic";
import dynamic from "next/dynamic";

import uuid from "react-uuid";
import VideosRow from "../components/Elements/VideosRow/VideosRow";
import { newsThumbnailsDeserializer } from "../components/Services/deserializer";
import SliderSkeleton from "../components/HomeCompo/Slider/SliderSkeleton";
import GridLinks from "../components/HomeCompo/GridLinks/GridLinks";

const VideoRow = dynamic(
  () => import("../components/HomeCompo/DKExploreHomeVideo/DKExploreHomeVideo"),
  {
    ssr: false,
    loading: SliderSkeleton,
  }
);

const Slider = dynamic(() => import("../components/HomeCompo/Slider/Slider"), {
  ssr: false,
  loading: SliderSkeleton,
});

export default function Home({
  newsData: newsDataJson,
  sliderData,
  videoData,
}) {
  const newsData = newsDataJson !== null ? JSON.parse(newsDataJson) : null;

  return (
    <>
      <Head>
        <title>درباره گروه دیجی‌کالا</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="گروه تجارت الکترونیک دیجی‌کالا اکنون به اکوسیستمی کامل برای تمامی
          کسب‌وکارهای آنلاین تبدیل شده است. رویکرد گروه دیجی‌کالا تکمیل زنجیره
          خلق ارزش برای اقتصاد دیجیتال ایران بوده و در این مسیر، زیرساخت‌های
          لازم برای پاسخگویی به نیازهای کسب‌وکارها را فراهم کرده است."
        />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta name="msvalidate.01" content="490A0580A866AD2C7FBDA153DE78E97E" />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <link rel="canonical" href="https://about.digikala.com/" />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="درباره گروه دیجی‌کالا" />
        <meta property="og:url" content="https://about.digikala.com/" />
        <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image" content="ogImage.jpg" />
        <meta property="og:image:width" content="500" />
        <meta property="og:image:height" content="500" />
        <meta property="og:image:alt" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image:type" content="image/png" />
        <meta
          property="og:site_name"
          content="درباره گروه دیجی‌کالا"
          key="ogsitename"
        />
        <meta
          property="og:title"
          content="درباره گروه دیجی‌کالا"
          key="ogtitle"
        />
        <meta
          property="og:description"
          content="گروه تجارت الکترونیک دیجی‌کالا اکنون به اکوسیستمی کامل برای تمامی
          کسب‌وکارهای آنلاین تبدیل شده است. رویکرد گروه دیجی‌کالا تکمیل زنجیره
          خلق ارزش برای اقتصاد دیجیتال ایران بوده و در این مسیر، زیرساخت‌های
          لازم برای پاسخگویی به نیازهای کسب‌وکارها را فراهم کرده است."
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="درباره گروه دیجی‌کالا" />
        <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
        <meta
          name="twitter:image"
          content="https://about.digikala.com/ogImage.jpg"
        />
        <meta
          name="twitter:description"
          content="گروه تجارت الکترونیک دیجی‌کالا اکنون به اکوسیستمی کامل برای تمامی
          کسب‌وکارهای آنلاین تبدیل شده است. رویکرد گروه دیجی‌کالا تکمیل زنجیره
          خلق ارزش برای اقتصاد دیجیتال ایران بوده و در این مسیر، زیرساخت‌های
          لازم برای پاسخگویی به نیازهای کسب‌وکارها را فراهم کرده است."
        />
      </Head>
      <Slider key={uuid()} data={sliderData} />
      <DKStatistic />
      <VideoRow />
      {/*<GridLinks />*/}
      <NewsRow data={newsData} />
      <ImageRow />
      <VideosRow data={videoData} />
    </>
  );
}

export async function getServerSideProps(context) {
  try {
    const newsRes = await fetch(
      `${process.env.NEWSROOM_API_BASE_URL}/wp-json/wp/v2/posts/?_embed&per_page=5&is_published=true`
    );
    const relNewsData = await newsRes.json();
    // const refactoredRelNewsData = relNewsData?.length
      // ? relNewsData?.map((item) => newsThumbnailsDeserializer(item))
      // : [];

    const filteredRelNewsData = relNewsData?.filter(item => (item.id !== 1010574) )?.map((item) => newsThumbnailsDeserializer(item)) ?? [];

    const sliderRes = await fetch(
      `${process.env.ABOUT_API_BASE_URL}/api/v1/homepage/sliders/fa/?is_published=true&language=fa`
    );
    const videosRes = await fetch(
      `${process.env.ABOUT_API_BASE_URL}/api/v1/videos/?is_published=true&language=FA`
    );

    const sliderData = await sliderRes.json();
    const videoData = await videosRes.json();
    return {
      props: {
        newsData: JSON.stringify(filteredRelNewsData),
        sliderData: sliderData,
        videoData: videoData,
      },
    };
  } catch (error) {
    console.error(error);
    return {
      props: { newsData: [], sliderData: [] },
    };
  }
}
